function stackTrace() {
    var err = new Error();
    return err.stack;
}

/*function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}*/

/**
 * Returns a random integer between min (inclusive) and max (inclusive)
 */
export function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * Returns a random float between min (inclusive) and max (exclusive)
 */
export function getRandomFloat(min, max) {
    return Math.random() * (max - min) + min;
}

export function getRandRadius(diameter) {

    var dir = Math.random() >= 0.5 ? -1 : 1;

    return getRandomInt(0, diameter / 2) * dir;
}